<template>
    <form @submit.prevent="submit">
        <div class="flex justify-between items-center">
            <h3>Jouw gegevens</h3>
        </div>

        <!-- Type -->
        <div class="col-span-6">
            <!-- <label for="phone" class="block text-sm h-5 font-semibold text-gray-700"> Type </label> -->
            <div class="flex items-center my-2 px-2">
                <span class="mr-6 flex items-center">
                    <input id="particulier" :value="1" v-model="form.type" type="radio" class="h-4 w-4 accent-dgreen" />
                    <label for="particulier" class="pl-3 block text-gray-700">Particulier</label>
                </span>

                <span class="flex items-center">
                    <input id="zakelijk" :value="2" v-model="form.type" type="radio" class="h-4 w-4 accent-dgreen" />
                    <label for="zakelijk" class="pl-3 block text-gray-700">Zakelijk</label>
                </span>
            </div>
        </div>

        <div class="mt-4 grid gap-y-4 gap-x-4 grid-cols-6">
            <!-- Name -->
            <div class="col-span-3">
                <label for="name" class="block text-sm h-5 font-semibold text-gray-700">Voornaam</label>
                <div class="mt-1">
                    <input
                        type="text"
                        name="first_name"
                        id="first_name"
                        autocomplete="given-name"
                        placeholder="Voornaam"
                        v-model="form.first_name"
                        class="text-input"
                        :class="!form.first_name && form.errors.first_name ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="!form.first_name && form.errors.first_name">
                            {{ form.errors.first_name }}
                        </div>
                    </transition>
                </div>
            </div>

            <div class="col-span-3">
                <label for="last_name" class="block text-sm h-5 font-semibold text-gray-700">Achternaam</label>
                <div class="mt-1">
                    <input
                        type="text"
                        name="last_name"
                        id="last_name"
                        autocomplete="family-name"
                        placeholder="Achternaam"
                        v-model="form.last_name"
                        class="text-input"
                        :class="!form.last_name && form.errors.last_name ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="!form.last_name && form.errors.last_name">
                            {{ form.errors.last_name }}
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Phone -->
            <div class="col-span-4">
                <label for="email" class="block text-sm h-5 font-semibold text-gray-700"> E-mail </label>
                <div class="mt-1">
                    <input
                        id="email"
                        name="email"
                        type="email"
                        autocomplete="email"
                        v-model="form.email"
                        class="text-input"
                        placeholder="E-mail"
                        :class="!form.email && form.errors.email ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="!form.email && form.errors.email">
                            {{ form.errors.email }}
                        </div>
                    </transition>
                </div>
            </div>
            <div class="col-span-4">
                <label for="phone" class="block text-sm h-5 font-semibold text-gray-700">
                    Telefoonnummer <span class="text-gray-500 font-light">(optioneel)</span>
                </label>
                <div class="mt-1">
                    <input
                        type="tel"
                        name="phone"
                        id="phone"
                        autocomplete="tel"
                        placeholder="06 123456789"
                        v-model="form.phone"
                        class="text-input"
                    />
                </div>
            </div>

            <!-- Company -->
            <div class="col-span-4" v-if="form.type == 2">
                <label for="company" class="block text-sm h-5 font-semibold text-gray-700">
                    Bedrijfsnaam <span class="text-gray-500 font-light">(optioneel)</span></label
                >
                <div class="mt-1">
                    <input
                        type="text"
                        name="company"
                        id="company"
                        autocomplete="company"
                        placeholder="Bedrijfsnaam"
                        v-model="form.company"
                        @change="collect('form.billing.company', form.billing.company)"
                        class="text-input"
                        :class="form.errors.company ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="form.errors.company">
                            {{ form.errors.company }}
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Subject -->
            <div class="col-span-6">
                <h3>Waarvoor wens je een offerte te ontvangen?</h3>
                <span class="flex items-center">
                    <input
                        id="sluitplan"
                        :value="1"
                        v-model="form.subject"
                        type="radio"
                        class="h-4 w-4 accent-dgreen"
                    />
                    <label for="sluitplan" class="pl-3 block text-gray-700">Sluitplan</label>
                </span>

                <span class="flex items-center">
                    <input
                        id="cilinders"
                        :value="2"
                        v-model="form.subject"
                        type="radio"
                        class="h-4 w-4 accent-dgreen"
                    />
                    <label for="cilinders" class="pl-3 block text-gray-700">Cilinders</label>
                </span>

                <span class="flex items-center">
                    <input id="overige" :value="3" v-model="form.subject" type="radio" class="h-4 w-4 accent-dgreen" />
                    <label for="overige" class="pl-3 block text-gray-700">Overige</label>
                </span>

                <transition name="pop">
                    <div class="error-text" v-if="!form.subject && form.errors.subject">
                        {{ form.errors.subject }}
                    </div>
                </transition>
            </div>

            <!-- Comment cylinders -->
            <div class="col-span-6" v-if="form.subject == 2">
                <!-- <h3>Cilinders</h3> -->
                <div class="w-full flex flex-wrap mb-6">
                    <div class="w-full md:w-1/2 md:pr-8 md:border-r">
                        <p>
                            Gemakkelijk en snel de cilinder op maat vinden met onze keuze hulp of geef hieronder meer
                            informatie over de cilinder(s) die je wenst te ontvangen.
                        </p>
                        <span @click="showWizard" class="button default">
                            Start keuzehulp <fa :icon="['fal', 'circle-play']" class="ml-2 w-5" />
                        </span>
                    </div>
                    <div class="w-full md:w-1/2 md:pl-8">
                        <p>Al een overzicht? Upload deze dan hier</p>
                        <form>
                            <label class="block">
                                <span class="sr-only">Upload overzicht</span>
                                <input
                                    type="file"
                                    @input="form.file = $event.target.files[0]"
                                    class="block w-full text-sm text-gray-800 file:mr-4 file:py-2 file:px-4 file:bg-white file:rounded-md file:border file:text-sm file:font-semibold hover:file:bg-gray-50"
                                />
                            </label>
                        </form>
                    </div>
                </div>

                <label for="comment" class="block text-sm h-5 font-semibold text-gray-700"> Aanvraag </label>
                <div class="mt-1">
                    <textarea
                        class="textarea text-input"
                        placeholder="Vermeld hier de maat, het aantal cilinders en het aantal sleutels dat je wenst te ontvangen."
                        v-model="form.comment"
                        rows="4"
                        cols="50"
                        :class="!form.comment && form.errors.comment ? 'text-input-failed' : ''"
                    ></textarea>
                    <transition name="pop">
                        <div class="error-text" v-if="!form.comment && form.errors.comment">
                            {{ form.errors.comment }}
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Comment other -->
            <div class="col-span-6" v-if="form.subject == 3">
                <!-- <h3>Overige</h3> -->
                <p>
                    Een offerte aanvragen voor gecombineerde producten of een overige vraag? Laat ons weten waar je een
                    offerte voor wil aanvragen.
                </p>
                <label for="comment" class="block text-sm h-5 font-semibold text-gray-700"> Aanvraag </label>
                <div class="mt-1">
                    <textarea
                        class="textarea text-input"
                        placeholder="Typ hier je aanvraag"
                        v-model="form.comment"
                        rows="4"
                        cols="50"
                        :class="!form.comment && form.errors.comment ? 'text-input-failed' : ''"
                    ></textarea>
                    <transition name="pop">
                        <div class="error-text" v-if="!form.comment && form.errors.comment">
                            {{ form.errors.comment }}
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Comment MKS -->
            <div class="col-span-6" v-if="form.subject == 1">
                <!-- <h3>Sluitplan</h3> -->
                <div class="w-full flex flex-wrap mb-6">
                    <div class="w-full md:w-1/2 md:pr-8 md:border-r">
                        <p>Gemakkelijk en snel een offerte aanvragen voor een sluitplan met onze configurator.</p>
                        <a href="/sluitplan-samenstellen" target="_blank" class="button default no-underline">
                            Naar configurator <fa :icon="['fal', 'angle-right']" class="ml-2"
                        /></a>
                    </div>
                    <div class="w-full md:w-1/2 md:pl-8">
                        <p>
                            Beschik je al over een overzicht?<br />
                            Upload deze dan hier
                        </p>

                        <form>
                            <label class="block">
                                <span class="sr-only">Upload overzicht</span>
                                <input
                                    type="file"
                                    @input="form.file = $event.target.files[0]"
                                    class="block w-full text-sm text-gray-800 file:mr-4 file:py-2 file:px-4 file:bg-white file:rounded-md file:border file:text-sm file:font-semibold hover:file:bg-gray-50"
                                />
                            </label>
                        </form>
                        <!-- 

                        <label class="button default no-underline">>Upload overzicht</label>
                        <input class="hidden" id="upload" type="file"> -->
                    </div>
                </div>

                <label for="comment" class="block text-sm h-5 font-semibold text-gray-700"> Aanvraag </label>
                <div class="mt-1">
                    <textarea
                        class="textarea text-input"
                        placeholder=""
                        v-model="form.comment"
                        rows="4"
                        cols="50"
                        :class="!form.comment && form.errors.comment ? 'text-input-failed' : ''"
                    ></textarea>
                    <transition name="pop">
                        <div class="error-text" v-if="!form.comment && form.errors.comment">
                            {{ form.errors.comment }}
                        </div>
                    </transition>
                </div>
                <div class="mt-4">
                    <label for="express" class="block text-sm h-5 font-semibold text-gray-700">Levering</label>
                    <span class="flex items-center">
                        <input
                            id="express1"
                            :value="1"
                            v-model="form.express"
                            type="radio"
                            class="h-4 w-4 accent-dgreen"
                        />
                        <label for="express1" class="pl-3 block text-gray-700">Binnen 5 werkdagen</label>
                    </span>
                    <span class="flex items-center">
                        <input
                            id="express2"
                            :value="2"
                            v-model="form.express"
                            type="radio"
                            class="h-4 w-4 accent-dgreen"
                        />
                        <label for="express2" class="pl-3 block text-gray-700">5 tot 10 werkdagen</label>
                    </span>
                </div>
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <button type="submit" :disabled="form.processing" class="button green w-full mt-6">
                <fa
                    :icon="['fad', 'spinner-third']"
                    class="text-white opacity-80 mr-2 fa-spin"
                    v-if="form.processing"
                />

                Aanvraag versturen
            </button>
        </div>
    </form>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3';
const inBrowser = typeof window !== 'undefined';
const emit = defineEmits(['close']);
import { onMounted } from 'vue';

const form = useForm({
    email: '',
    first_name: '',
    last_name: '',
    comment: '',
    phone: '',
    company: '',
    file: '',
    type: 1,
    subject: '',
    express: '',
    errors: {},
});

onMounted(() => {
    dataLayer.push({ event: 'StartQuoteForm' });
    if (typeof hj !== 'undefined') {
        hj('event', 'StartQuoteForm');
    }
});

function showWizard(n) {
    if (inBrowser) {
        emit('close');
        window.mitt.emit('open-wizard', true);
    }
}

function submit() {
    let self = this;

    form.post('/quote/request', {
        preserveScroll: true,

        onSuccess() {
            emit('close');
            dataLayer.push({ event: 'CompletedQuoteForm' });
            if (typeof hj !== 'undefined') {
                hj('event', 'CompletedQuoteForm');
            }
        },
    });
}
</script>
